export default function (other) {
  other = other || {}
  return {
    ids: other.ids,
    symbol: other.symbol,
    symbols: other.symbols,
    names: other.names,
    exchanges: other.exchanges,
    groups: other.groups,
    pagination: other.pagination,
    description: other.description,
    types: other.types,
    activeOnly: other.activeOnly,
    search: other.search,
  }
}
